import { useQuery } from '@tanstack/react-query';

import { FormulaType } from '../../constants/formulaType';

// helpers
import { BaseError } from '../../helpers/BaseError';

// models
import { EmailTemplateModel } from '../../models/formula.model';

// services
import API from '../../services/api';

import emailTemplateKeys from './_queryKeys';

const getTemplate = async (templateId: string): Promise<EmailTemplateModel> => {
    const { data } = await API.fetchEmailTemplate(templateId);
    const dynamicFieldsWithModifiers = data.dynamic_keys.filter(
        (field: string) => field.includes('--'),
    );
    const dynamicFieldsWithoutModifiers = data.dynamic_keys.filter(
        (field: string) => !field.includes('--'),
    );
    return {
        htmlContent: data.html_content,
        dynamicFieldsWithModifiers,
        dynamicFieldsWithoutModifiers,
    };
};

export default function useQueryEmailTemplate(
    templateId: string,
    formulaType: FormulaType,
    enabled: boolean = true,
) {
    return useQuery<EmailTemplateModel, BaseError>({
        queryKey: emailTemplateKeys.templateId(templateId),
        queryFn: () => getTemplate(templateId),
        enabled: !!templateId && formulaType === FormulaType.email && enabled,
        staleTime: 2 * 60 * 60,
    });
}
